export default __webpack_public_path__ + "static/media/driver-detection.9cc791ea.jpg";